import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
import { Tokens } from '../../Models/tokens';
import { CommonService } from '../Abstract/commons.service';
import { ConfigService } from '../Abstract/config.service';
import { EventsEmitterService } from '../Abstract/emitter.service';
import { Router, RouterModule, Routes, Route, } from '@angular/router';
import { LogService } from '../Abstract/log.service';

@Injectable()
export class AuthService extends CommonService {

  private readonly JWT_TOKEN = 'access_token';
  private readonly REFRESH_TOKEN = 'refresh_token';
  private loggedUser: string;

  constructor(http: HttpClient, configService: ConfigService, protected eventsEmitterService: EventsEmitterService, public router: Router, logger: LogService) {
    super(http, configService, logger);
  }

  login(user: { username: string, password: string }): Observable<boolean> {
    return this.http.post<any>(`${this.baseUrl}/login`, user)
      .pipe(
        tap(tokens => this.doLoginUser(user.username, tokens)),
        mapTo(true),
        catchError(error => {
          alert(error.error);
          return of(false);
        }));
  }

  public logout(timeout = false) {
    this.logoutLog().subscribe(
    (response) => {
        this.logger.log("The logout action was logged: " + JSON.stringify(response));
        if (timeout){
          let errMsg = JSON.parse(localStorage.getItem('visualsArray' +  '_' + 
                                              localStorage.getItem('langId') ))['generic']['valid_logout'];
          LogService.emitAlert({
            type: 'error',
            body: errMsg
          });
        }
        this.router.navigateByUrl('/login?lang=' + localStorage.getItem('langId'));
        this.clearStorages();
      },
      (error) => {
        this.logger.log("Could not log the logout action: " + JSON.stringify(error));
        this.router.navigateByUrl('/login?lang=' + localStorage.getItem('langId'));
        this.clearStorages();
      }
    );
    
  }

  public logoutLog() {
    let baseUrl = this.configService.getServer()
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers.set('Authorization','Bearer '+ this.getFromStorage('access_token'));
    let options =  ({ headers: headers });
    let credentials = "access_token=" + this.getFromStorage('access_token');
    let serviceUrl = baseUrl + 'LoginService/logout';
    return this.http.post(serviceUrl, credentials, options).pipe(map(this.extractData));
   }

  isLoggedIn() {
    return !!this.getJwtToken();
  }

  public refreshToken(): Observable<HttpResponse<any>> {
    let baseUrl = this.configService.getServer()
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = { 'headers': headers };
    let credentials = "grant_type=refresh_token"
      + '&client_id=angular2-client'
      + '&client_secret=angular2'
      + "&refresh_token=" + this.getFromStorage('refresh_token')
      + "&access_token=" + this.getFromStorage('access_token');
    let serviceUrl = baseUrl + 'oauth/token';

    return this.http.post(serviceUrl, credentials, options).pipe(map((x: HttpResponse<any>) => this.saveData(x)), catchError(this.handleError));
  }
  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  private doLoginUser(username: string, tokens: Tokens) {
    this.loggedUser = username;
    this.storeTokens(tokens);
  }

  private doLogoutUser() {
    this.loggedUser = null;
    this.removeTokens();
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeJwtToken(jwt: string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);
  }

  private storeTokens(tokens: Tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.jwt);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refreshToken);
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }
}